import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider } from './auth/AuthContext';
import AuthRoutes from './auth/AuthRoutes';

const theme = createTheme({ palette: { primary: { main: '#245c50' } } });
export default function App() {
  return <ThemeProvider theme={theme}><CssBaseline /><BrowserRouter>
    <AuthProvider><AuthRoutes /></AuthProvider>
  </BrowserRouter></ThemeProvider>;
}
